import React from 'react';

export default function SignUpQuery( {setKnowsPassword} ) {

    return (
        <h3 className={"text-lg text-white/75"}>
            Forgot your password? <span onClick={() => setKnowsPassword(false)} className={"text-white underline cursor-pointer"}> Reset password</span>
        </h3>
    );
}